import { Capacitor } from '@capacitor/core'
import { environment } from '../../environments/environment'

export const WEB_APP_API_URL = '/api/app'

export function resolveAppApiUrl(isNativePlatform = Capacitor.isNativePlatform()): string {
  return isNativePlatform ? environment.appApi : WEB_APP_API_URL
}
